import NavSlot from "@/components/navigation/links";
import { Outlet } from "react-router-dom";
import MyTeamTimesheetTable from "./timesheet";
import MyTeamAcknowledgementTable from "./acknowledgement";

export const TimesheetMyTeamStatus = [
    {
        label: "Timesheet",
        value: "timesheet",
        path: "/timesheet/my-team/timesheet",
        element: MyTeamTimesheetTable,
    },
    {
        label: "Acknowledge",
        value: "acknowledge",
        path: "/timesheet/my-team/acknowledge",
        element: MyTeamAcknowledgementTable,
    },
];

const TimesheetMyTeamLayout = () => {
    return (
        <div className="flex-1 overflow-auto relative ">
            <div className="sticky w-full bg-white z-1">
                <NavSlot navItems={TimesheetMyTeamStatus} />
            </div>
            <Outlet />
        </div>
    );
};

export default TimesheetMyTeamLayout;
